<template>
  <!-- ユーザ編集 -->
  <div id="AppUserManagementAddUserTab">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--ユーザ情報 -->
    <editUserContents ref="editContents" />
    <!-- 下部余白 -->
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full" style="text-align:center;">
        <b-button
          class="button"
          type="is-primary"
          icon-right="content-save"
          native-type="button"
          @click="doSave"
        >登録</b-button>
        <b-button
          class="button"
          type="is-primary"
          icon-right="eraser"
          native-type="button"
          @click="doClear"
        >クリア</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import tabContents from "./AppUserManagementAddUserContents";
export default {
  name: "AppUserManagementAddUserTab",
  methods: {
    doSave: function(event) {
      this.$refs.editContents.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.editContents.doSave();
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doClear: function(event) {
      this.$refs.editContents.doClear();
    }
  },
  data() {
    return {};
  },
  components: {
    editUserContents: tabContents
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementAddUserTab.vue